<template>
  <div class="cont">
    <div class="box">
       <div class="title">
        <div class="xian"></div>
        <div>结构树</div>
      </div>
      <div  style="text-align: center;padding-top:20px">
        <el-select  v-model="mokuai"  placeholder="请选择" filterable @change="mukuaiChange">
          <el-option v-for="val in mokuaiListSearch" :label="val.name" :value="val.name" :key="val.id"></el-option>
        </el-select>
        <el-button type="primary" @click="reSet()" style="margin-left: 20px;" >重置</el-button>
      </div>
      <div class="mokuaiBox" >
        <h4 v-if="mokuaiList.length>0">WEB端模块:</h4>
        <ul >
          <li v-for="item in mokuaiList" :key="item.id">
            <p :class="{mokuai:true,active:item.id==currentData.moduleId}" @click="mokuaiFn(item)"><i class="fa fa-hand-o-right" aria-hidden="true"></i> {{item.name}}</p>
            <div class="shuBox" v-if="item.id==currentData.moduleId">
              <el-tree
                :data="caidanTree"
                :props="defaultProps"
                ref="menuTree"
                node-key="id"
                :current-node-key="currentData.parentId"
                :default-expanded-keys="[currentData.parentId]"
                :highlight-current="true"
                @node-click="handleNodeClick"
                 :render-content="renderContent"
              >
            </el-tree>
          </div>
          </li>
        </ul>
          <h4 v-if="mokuaiListAPP.length>0">APP端模块:</h4>
        <ul>
          <li v-for="item in mokuaiListAPP" :key="item.id">
            <p :class="{mokuai:true,active:item.id==currentData.moduleId}" @click="mokuaiFn(item)"><i class="fa fa-hand-o-right" aria-hidden="true"></i> {{item.name}}</p>
            <div class="shuBox" v-if="item.id==currentData.moduleId">
              <el-tree
                :data="caidanTree"
                :props="defaultProps"
                ref="menuTree"
                node-key="id"
                :current-node-key="currentData.parentId"
                :default-expanded-keys="[currentData.parentId]"
                :highlight-current="true"
                @node-click="handleNodeClick"
                 :render-content="renderContent"
              >
            </el-tree>
          </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
       <div class="title">
        <div class="xian"></div>
        <div>列表</div>
      </div>
      <div>
        <div class="rightTop">
            <h4>{{cName}}</h4>
            <el-button type="primary" @click="addFn"  v-if="addFlag">添加</el-button>
        </div>
        <div class="table" :style="{height:h}">
            <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  style="width: 100%" height="100%"  center border>
              <el-table-column prop type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column label="操作"  width="120">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="tingqiFN(scope.row)">{{scope.row.enableFlag==1?'停用':'启用'}}</el-button>
                    <el-button type="text" size="mini"  @click="editFn(scope.row)">修改</el-button>
                    <el-button type="text" size="mini"  v-if="scope.row.enableFlag==0"  @click="delFn(scope.row)">删除</el-button>
                  </template>
              </el-table-column>
              <el-table-column property="type" label="类型" min-width="100">
                  <template scope="scope">
                    <div> {{[ "菜单", "按钮"][scope.row.type-1]}}</div>
                  </template>
              </el-table-column>
              <el-table-column prop="name" min-width="150"  label="名称"  align="center"></el-table-column>
              <el-table-column prop="aliasName" :formatter="emptyFn"  min-width="150"  label="别名"  align="center"></el-table-column>
              <el-table-column prop="code"  min-width="160" label="编码"  align="center"></el-table-column>
              <el-table-column prop="sort"  label="顺序"  align="center"></el-table-column>
              <el-table-column prop="accessUrl" :formatter="emptyFn" min-width="160" label="地址"  align="center"></el-table-column>
              <el-table-column property="enableFlag" label="启用状态" min-width="100">
                  <template scope="scope">
                    <div> {{[ "否", "是"][scope.row.enableFlag]}}</div>
                  </template>
              </el-table-column>
              <el-table-column prop="remark" min-width="150" :formatter="emptyFn" label="备注"  align="center"></el-table-column>
              <el-table-column prop="createUserName" min-width="100" :formatter="emptyFn" label="创建人"></el-table-column>
              <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
            </el-table>
        </div>
      </div>
    </div>
    <!-- 添加修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false"  :close-on-press-escape="false"  class="jiaoyan"  :visible.sync="dialogVisible"  @close="closeDialog"  width="470px"  center >
      <div>
        <el-form  :model="addFrom"  :rules="rules"  ref="addFrom" class="demo-form-inline "   label-width="130px"  size="mini" >
          <div class="addinpBox">
             <el-form-item label="添加类型:" prop="type">
                <el-select  v-model="addFrom.type"  placeholder="请选择" style="width: 210px;" :disabled="typeFlag">
                  <el-option label="菜单" :value=1></el-option>
                  <el-option label="按钮" :value=2></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="addFrom.type==2?'按钮名称:':'菜单名称:'" prop="name">
              <el-input   maxlength="50"  :validate-event="false"  placeholder  v-model.trim="addFrom.name"  ></el-input>
            </el-form-item>
            <el-form-item :label="addFrom.type==2?'按钮别名:':'菜单别名:'" prop="aliasName">
              <el-input   maxlength="50"  :validate-event="false"  placeholder  v-model.trim="addFrom.aliasName"  ></el-input>
            </el-form-item>
           <el-form-item label="顺序:" prop="sort">
              <el-input   maxlength="3" v-number-input.float="0"  :validate-event="false"  placeholder  v-model.trim="addFrom.sort"  ></el-input>
            </el-form-item>
            <el-form-item label="地址:" prop="accessUrl">
              <el-input placeholder maxlength="100" v-model.trim="addFrom.accessUrl"></el-input>
            </el-form-item>
            <el-form-item label="图标:" prop="picType">
              <template>
                <el-radio v-model="addFrom.picType" label="0">图标URL</el-radio>
                <el-radio v-model="addFrom.picType" label="1">图标样式</el-radio>
              </template>
            </el-form-item>
            <el-form-item label prop="picName">
              <el-input placeholder maxlength="300" v-model.trim="addFrom.picName"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <el-input placeholder maxlength="200" v-model.trim="addFrom.remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn('addFrom')" >保 存</el-button>
        <el-button @click="dialogVisible=false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { listModule, sMenuAdd, sMenuTreeByModuleId, sMenuDelete, sMenuUpdate, childrenList, enableOrDisable } from '@/api/newCrm'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: 500,
      mokuai: null,
      mokuaiList: [],
      mokuaiListAPP: [],
      mokuaiListSearch: [],
      currentData: {}, // 当前选中得模块id ，菜单按钮模块code，父id
      caidanTree: [],
      cName: '',
      tableList: [],
      loading: false,
      // 新增修改
      addFrom: {},
      isAdd: true,
      dialogVisible: false,
      title: '添加',
      rules: {
        type: [
          { required: true, message: '请选择添加类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        // accessUrl: [
        //   { required: true, message: '请输入菜单地址', trigger: 'blur' }
        // ],
        sort: [{ required: true, message: '请输入顺序', trigger: 'blur' }]
      },
      typeFlag: false,
      addFlag: true,
      node: {},
      defaultProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  created () {
    listModule().then(res => {
      this.mokuaiList = res.WEB
      this.mokuaiListAPP = res.APP
      this.mokuaiListSearch = res.WEB.concat(res.APP)
    })
  },
  mounted () {
    let pH = document.documentElement.clientHeight
    this.h = (pH - 150) + 'px'
  },
  methods: {
    // 树得格式化
    renderContent (h, { node, data, store }) {
      if (data.aliasName) {
        return (
          <span class="custom-tree-node" >
            <span style="font-size:14px">{data.name + '（' + data.aliasName + '）'}</span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:14px">{data.name }</span>
          </span>)
      }
    },
    // 选择模块
    mukuaiChange () {
      listModule({ name: this.mokuai }).then(res => {
        this.mokuaiList = res.WEB
        this.mokuaiListAPP = res.APP
      })
    },
    reSet () {
      this.mokuai = ''
      listModule().then(res => {
        this.mokuaiList = res.WEB
        this.mokuaiListAPP = res.APP
      })
    },
    // 添加
    addFn () {
      if (this.currentData.moduleId) {
        this.dialogVisible = true
        this.isAdd = true
        if (this.tableList[0]) {
          this.$set(this.addFrom, 'type', this.tableList[0].type)
        }
        for (let key in this.currentData) {
          this.addFrom[key] = this.currentData[key]
        }
        let data = this.$refs.menuTree[0].getCurrentNode()
        let node = this.node
        if (node) {
          this.$set(this.addFrom, 'parentType', data.type)
          if (data.type == 1) {
            this.addFlag = true
            if (node.level == 3) { // 三级菜单只能添加按钮
              this.typeFlag = true
              this.$set(this.addFrom, 'type', 2)
            } else {
              if (data.children.length == 0) {
                this.typeFlag = false
              } else {
                this.typeFlag = true
                this.$set(this.addFrom, 'type', data.children[0].type)
              }
            }
          } else {
            if (node.parent.data.type == 2) {
              this.addFlag = false
            } else {
              this.typeFlag = true
              this.$set(this.addFrom, 'type', 2)
            }
          }
        } else {
          this.$set(this.addFrom, 'parentType', '')
          this.typeFlag = true
          this.$set(this.addFrom, 'type', 1)
        }
      } else {
        this.$alert('请选择模块', '系统提示')
      }
    },
    // 修改
    editFn (row) {
      this.dialogVisible = true
      this.isAdd = false
      this.addFrom = { ...row }
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sMenuAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getTreeList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sMenuUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getTreeList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 停用启用
    tingqiFN (row) {
      let str = ''
      if (row.enableFlag == 1) { // 启用状态
        str = '停用'
      } else {
        str = '启用'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        enableOrDisable({ id: row.id, enableFlag: row.enableFlag == 1 ? 0 : 1, parentId: this.currentData.parentId }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getTreeList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    delFn  (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sMenuDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTreeList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 点击模块
    mokuaiFn (item) {
      this.cName = item.name
      this.currentData = {
        moduleId: item.id,
        parentId: 0,
        parentCode: item.code
      }
      this.caidanTree = []
      this.typeFlag = true
      this.node = null
      sMenuTreeByModuleId({ moduleId: this.currentData.moduleId }).then(res => {
        this.caidanTree = res
        this.tableList = res
      })
    },
    // 点击树
    handleNodeClick (data, node) {
      this.currentData.parentId = data.id
      this.currentData.parentCode = data.code
      this.tableList = data.children
      this.cName = data.name
      this.node = node
      if (data.enableFlag == 1) {
        this.addFlag = true
        this.$set(this.addFrom, 'parentType', data.type)
        if (data.type == 1) {
          if (node.level == 3) { // 三级菜单只能添加按钮
            this.typeFlag = true
            this.$set(this.addFrom, 'type', 2)
          } else {
            if (data.children.length == 0) {
              this.typeFlag = false
            } else {
              this.typeFlag = true
              this.$set(this.addFrom, 'type', data.children[0].type)
            }
          }
        } else {
          if (node.parent.data.type == 2) {
            this.addFlag = false
          } else {
            this.typeFlag = true
            this.$set(this.addFrom, 'type', 2)
          }
        }
      } else {
        this.addFlag = false
      }
    },
    getTreeList () {
      sMenuTreeByModuleId({ moduleId: this.currentData.moduleId }).then(res => {
        this.caidanTree = res
        this.$nextTick(function () {
          this.$refs.menuTree[0].setCurrentKey(this.currentData.parentId)
        })
        childrenList({ parentId: this.currentData.parentId, moduleId: this.currentData.moduleId }).then(res => {
          this.tableList = res
        })
      })
    },
    closeDialog () {
      this.addFrom = {}
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
    }
  }
}
</script>

<style scoped lang='less'>
.rightTop{
  display: flex;
  padding: 0 30px;
  align-items: center;
  h4{
    padding-right: 30px;
  }
}
.mokuaiBox{
  height: calc(100vh - 160px);
  overflow: auto;
}
.mokuai{
    margin: 0;
    padding: 10px;
    background: #eef4f9;
    border-bottom: 1px solid #b3bfcb;
    padding-left: 30px;
    font-size: 14px;
    .fa{
      color: #0e6eec;
    }
}
.active{
  background: #409EFF ;
  color: #fff;
  .fa{
      color: #fff;
  }
}
.mokuai:hover{
  background: #409EFF ;
  color: #fff;
  .fa{
      color: #fff;
  }
}
.boxShu{
  height: calc(100% - 36px);
  overflow: auto;
}
.cont{
  display: flex;
  height: 100%;
}
.box{
  width: 360px;
  border-right: 1px dashed #ddd;
  flex: 0 0 360px;
}
.right{
  width: calc(100% - 361px);
}
.title{
  width: 100%;
  height:36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  margin-top: -12px;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.addinpBox .el-input {
  width: 210px;
}
/deep/.el-checkbox__inner{
      width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
.shuBox{
  padding: 10px 0;
  padding-left: 38px;
  /deep/.el-tree-node__content{
    height: 32px;
  }
}
</style>
